<script lang="ts">
    import { spaLink } from "../../../actions"

    export let entry: ContentEntryTypeNews,
        path = ""
    const day = new Date(entry?.meta?.date).getDate()
    const month = new Date(entry?.meta?.date).getMonth() + 1
    const year = new Date(entry?.meta?.date).getFullYear()
</script>

<li>
    <a href="{path}" use:spaLink>
        <div class="left">
            <em>
                {day}.{month}.
            </em>
            <small>{year}</small>
        </div>
        <em class="right">
            {entry.name}
        </em></a
    >
</li>

<style lang="less">
    li,
    li a {
        display: flex;
        gap: calc(var(--default-gap) / 2);
        width: 100%;

        .left {
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding: 6px 24px 6px 0px;
            min-width: 75px;
            border-right: 1px solid var(--grey-200);
            em {
                line-height: 13px;
            }
        }
        .right {
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
    }
</style>
